import {
    makeStyles,
} from 'app/tss'

const serviceCenterMetrics = 'serviceCenterMetrics'
const productMetrics = 'productMetrics'
const storages = 'storages'

const useStyles = makeStyles()((theme) => {
    return {
        gridWrapper: {
            display: 'grid',
            gap: theme.spacing(2),
            gridTemplateAreas: `
                "${serviceCenterMetrics}"
                "${productMetrics}"
                "${storages}"
                `,
            gridTemplateColumns: 'repeat(1, 1fr)',
        },
        serviceCenterMetrics: {
            gridArea: serviceCenterMetrics,
        },
        productMetrics: {
            gridArea: productMetrics,
        },
        storages: {
            gridArea: storages,
        },
    }
})

export default useStyles
